import React from "react";
import {FormattedMessage} from "react-intl";

import ErrorMessage from "@toolbox/design/ErrorMessage";
import T from "@translate/T";

class Corrupted extends React.PureComponent {
    public render() {
        return (
            <ErrorMessage header={<T>Corrupted</T>}>
                <FormattedMessage
                    id="Your document is corrupted and cannot be shown."
                    defaultMessage="Your document is corrupted and cannot be shown."
                />
            </ErrorMessage>
        );
    }
}

export default Corrupted;
